import styled from "@emotion/styled";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";
import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";

const VirtualTour = () => {
  const { virtualTour } = usePropertyDetailPage();

  if (!virtualTour) return <></>;

  return (
    <Container>
      <TextSimple color="blue" size="title" font="gotham">
        Tour Virtual
      </TextSimple>

      <Content>
        <iframe src={virtualTour} allowFullScreen />
      </Content>
    </Container>
  );
};

export default VirtualTour;

const Container = styled.div`
  width: 100%;
  margin-top: 20px;
  border: 0px solid #ccc;
  border-radius: 20px;
  background: #fff;
  padding: 50px 40px;
`;

const Content = styled.div`
  margin-top: 20px;
  border-radius: 20px;
  iframe {
    border-radius: 20px;
    width: 100%;
    height: 430px;
    border: 0px solid #000;
  }
`;
